module.exports = __webpack_public_path__ + "static/media/Cswell.f8b1a223.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Cswell.png
// module id = 119
// module chunks = 0